
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Urbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Urbania on Rent in Pune',
        heading: 'S9 Travels: Urbania on Rent in Pune',
        headingDescription: 'S9 Travels offers Urbania on Rent in Pune, providing a spacious, comfortable, and reliable travel experience for group trips, family outings, corporate travel, and more. Our well-maintained Tata Urbania vehicles come with modern features, ample legroom, and professional drivers to ensure a smooth and hassle-free journey. Enjoy affordable pricing, on-time service, and 24/7 availability for your travel needs. Book your Urbania on Rent in Pune with S9 Travels for a comfortable and convenient ride!',


        top: 'Top Places to Visit in Pimpri Chinchwad with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada was built in 1732 by the Peshwas of the Maratha Empire. Once the seat of the Peshwa rulers, this grand palace is known for its magnificent architecture, massive gateways, and intriguing legends. The evening light and sound show offers a captivating retelling of its history, making it a must-visit for history lovers."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, this stunning palace holds great historical significance. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters during the Indian independence movement. The palace is surrounded by lush gardens and houses a museum displaying artifacts related to Gandhi's life and legacy."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. This fort, which was the site of the historic Battle of Sinhagad in 1670, is a favorite among trekking enthusiasts. Visitors can explore the ruins, pay homage to the brave warrior Tanaji Malusare, and enjoy local delicacies like pithla bhakri at nearby food stalls."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene retreat for spiritual seekers. It offers a variety of meditation programs, wellness sessions, and yoga classes in a peaceful environment. The ashram attracts visitors from across the globe looking to rejuvenate their mind and body through mindfulness and meditation."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, Pataleshwar Cave Temple dates back to the 8th century. Carved out of a single basalt rock, this temple features beautiful stone pillars and a sanctum with a Shiva Lingam. The tranquil atmosphere makes it an ideal spot for those seeking a blend of history, spirituality, and ancient architecture."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This unique museum houses an extensive collection of over 20,000 artifacts, including sculptures, paintings, weapons, musical instruments, and everyday household items from different periods of Indian history. It provides a fascinating insight into the artistic heritage of Maharashtra and India as a whole."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "A scenic getaway just a short drive from Pune, Khadakwasla Dam is a perfect spot for nature lovers and picnickers. The dam, which supplies water to Pune, offers stunning views of the reservoir and nearby hills. The cool breeze and peaceful surroundings make it an excellent location for a leisurely evening outing."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known for its vibrant and youthful energy, Fergusson College Road is a popular hangout spot among students and young travelers. It is lined with cafes, bookstores, street vendors, and shopping outlets. Whether you're looking for trendy fashion, delicious street food, or a lively atmosphere, this street has something for everyone."
    },
    {
      "title": "Lal Mahal",
      "description": "A historically significant landmark, Lal Mahal was originally built in the 1630s by Shahaji Bhosale for his son, Chhatrapati Shivaji Maharaj. Though the original structure was destroyed, the reconstructed Lal Mahal offers a glimpse into the childhood of Shivaji Maharaj and features paintings and artifacts related to his life."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully designed landscape park is inspired by the Korakuen Garden in Okayama, Japan. It features manicured lawns, flowing streams, koi ponds, and traditional Japanese-style architecture. It's a perfect place for a peaceful stroll or a relaxing family outing."
    }
],

"services": [
  {
    "name": "Urbania on Rent in Pune",
    "description": "Rent a spacious and comfortable Urbania car in Pune with S9 Travels. Whether for local travel, group trips, or special events, our Urbania rentals provide ample space and comfort for a smooth and enjoyable ride. We offer flexible rental options tailored to your travel needs, ensuring a hassle-free experience."
  },
  {
    "name": "Rent Urbania Car in Pune",
    "description": "Book an Urbania car for your travel in Pune with S9 Travels. Our Urbania rental service offers convenient and reliable transportation, perfect for both personal and business needs. Enjoy a comfortable, spacious ride with professional chauffeurs, making your journey around Pune a pleasant one."
  },
  {
    "name": "Affordable Urbania Rental Service in Pune",
    "description": "Looking for an affordable Urbania rental in Pune? S9 Travels offers budget-friendly rates without compromising on comfort and quality. Our Urbania cars are well-maintained and provide a comfortable experience for short and long trips, making it the perfect choice for any occasion."
  },
  {
    "name": "Book Urbania Car for Travel in Pune",
    "description": "Book an Urbania car for your travel in Pune with S9 Travels. Whether you're exploring the city or need transportation for business or leisure, our Urbania cars provide ample space, comfort, and convenience. Enjoy a smooth and safe ride with our reliable and professional drivers."
  },
  {
    "name": "Urbania Hire for Group Travel in Pune",
    "description": "Planning a group trip in Pune? Hire an Urbania car with S9 Travels for your group travel needs. With plenty of room for large groups, our Urbania cars offer a comfortable and enjoyable ride. Whether it’s a family trip, corporate outing, or friends’ get-together, we provide group-friendly transportation."
  },
  {
    "name": "Urbania Car Rental for Pune Tours",
    "description": "Experience Pune’s top attractions with an Urbania car rental from S9 Travels. Our comfortable, spacious vehicles are perfect for sightseeing tours, offering both comfort and convenience. Whether you're visiting historical landmarks or exploring the city’s vibrant culture, our Urbania rentals ensure a smooth and enjoyable journey."
  },
  {
    "name": "Luxury Urbania Rental in Pune",
    "description": "Indulge in luxury with an Urbania rental in Pune from S9 Travels. Our luxury Urbania cars come with top-notch amenities and offer a premium ride experience. Whether for business, leisure, or a special occasion, enjoy a lavish, comfortable journey with a professional chauffeur at your service."
  },
  {
    "name": "Urbania for Outstation Travel from Pune",
    "description": "Travel outstation from Pune in style with an Urbania car rental from S9 Travels. Our Urbania vehicles are perfect for long-distance travel, offering ample space and comfort. Whether it's a family vacation, corporate trip, or leisure travel, our Urbania cars ensure a safe and comfortable journey to your destination."
  },
  {
    "name": "Urbania Rent for Special Occasions in Pune",
    "description": "Make your special occasion even more memorable with an Urbania car rental in Pune. Whether it's a wedding, anniversary, or any other celebration, our Urbania cars provide a luxurious and comfortable way to travel. Enjoy a premium ride with professional chauffeurs to ensure your event is unforgettable."
  }
],

"tableData": [
  ["Urbania on Rent in Pune", "Rent Urbania Car in Pune"],
  ["Affordable Urbania Rental Service in Pune", "Book Urbania Car for Travel in Pune"],
  ["Urbania Hire for Group Travel in Pune", "Urbania Car Rental for Pune Tours"],
  ["Luxury Urbania Rental in Pune", "Urbania for Outstation Travel from Pune"],
  ["Urbania Rent for Special Occasions in Pune", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Ride",
    "WhyChoosedescription": "S9 Travels offers Force Urbania on rent in Pune, providing a comfortable and spacious ride for group travel. With ample seating capacity ranging from 9 to 17 seats, it ensures a relaxed journey for large groups, business trips, or family outings."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of punctuality. Our Urbania rental service in Pune ensures timely pick-ups and drop-offs, so you can depend on us to reach your destination on time, every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are well-versed with the best routes and road conditions in Pune and surrounding areas. They prioritize safety, comfort, and efficiency, ensuring your journey in the Urbania is smooth and pleasant."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive rates for Force Urbania rentals in Pune. We provide clear and transparent pricing with no hidden charges, ensuring you can easily plan your travel budget without any surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort During Your Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our Force Urbania vehicles are equipped with modern safety features such as GPS tracking, airbags, and seat belts to ensure a safe and comfortable experience for you and your group."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Urbania rental in Pune. Whether you need the vehicle early in the morning or late at night, we’re here to accommodate your travel needs."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Urbania Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way or have special requirements for your trip, we offer customizable itineraries to make your journey in the Urbania even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Force Urbania rental in Pune with S9 Travels is easy and hassle-free. You can book online through our website or mobile app, or contact our customer service team for personalized assistance to make your booking experience seamless."
  }
]












    }

    const faqData = [
        [
          {
            question: 'How can I rent an Urbania in Pune?',
            answer: 'Renting an Urbania in Pune is easy! You can book your rental through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a hassle-free rental experience.',
          },
          {
            question: 'What types of Urbania vehicles are available for rent in Pune?',
            answer: 'We offer different variants of Urbania vehicles for rent in Pune, including premium, standard, and luxury models. Choose the one that fits your travel needs and group size.',
          },
          {
            question: 'How long can I rent an Urbania in Pune?',
            answer: 'You can rent an Urbania in Pune for as long as you need! Whether it’s a few hours, a day, or longer, we provide flexible rental options to suit your schedule and requirements.',
          },
          {
            question: 'Do you provide drivers with the Urbania rental in Pune?',
            answer: 'Yes, we provide experienced and professional drivers with all Urbania rentals in Pune. Our drivers are familiar with the city routes and will ensure your comfort and safety during the journey.',
          },
          {
            question: 'How much does it cost to rent an Urbania in Pune?',
            answer: 'The rental cost depends on the model of Urbania you choose, the duration of your rental, and any additional services. Contact us for a customized quote based on your specific needs.',
          },
          {
            question: 'Is there a security deposit required to rent an Urbania in Pune?',
            answer: 'Yes, a refundable security deposit is required when renting an Urbania. The amount will vary depending on the model of the vehicle and rental duration.',
          },
          {
            question: 'Can I pick up the Urbania from a specific location in Pune?',
            answer: 'Yes, we offer flexible pick-up options. You can pick up your rented Urbania from a location of your choice in Pune, including your home, office, or any other convenient spot.',
          },
          {
            question: 'Can I extend my Urbania rental if I need more time?',
            answer: 'Yes, you can extend your Urbania rental in Pune based on availability. Simply contact our customer service team, and they will assist you with the extension.',
          },
          {
            question: 'Do you offer delivery and pick-up services for Urbania rentals in Pune?',
            answer: 'Yes, we offer delivery and pick-up services for your Urbania rental. We will ensure that the vehicle is delivered to your location and picked up at the end of your rental period.',
          },
          {
            question: 'Why should I choose S9 Travels for renting an Urbania in Pune?',
            answer: 'S9 Travels offers reliable, affordable, and comfortable Urbania rentals in Pune. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a smooth and enjoyable rental experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I rented an Urbania from S9 Travels for a trip around Pune, and the experience was outstanding. The vehicle was comfortable, and the driver was friendly and professional. The entire process was smooth, and we had a wonderful journey. I highly recommend S9 Travels for anyone looking to rent a vehicle in Pune!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We rented an Urbania for a family outing in Pune, and it was a fantastic experience. The vehicle was spacious, clean, and very comfortable. The driver was courteous and knowledgeable, and we had a smooth ride throughout. We will definitely consider S9 Travels for our future rentals in Pune!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Urbania on Rent in Pune",
        "description": "Book affordable and luxury Urbania car rental services in Pune. Whether for group travel, special occasions, outstation trips, or tours, S9 Travels offers a reliable Urbania rental service in Pune for all your transportation needs.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Urbania on Rent in Pune | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Urbania on rent in Pune for group travel, tours, special occasions, or outstation trips. Affordable, luxury Urbania rental services for comfortable and stylish travel with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
     
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinpune;